import React from 'react';
const stats = [{
  value: '+1.000',
  label: 'allenatori',
  color: 'text-[#16A34A]'
}, {
  value: '5+5',
  label: 'Volumi + Bonus',
  color: 'text-[#16A34A]'
}, {
  value: '4.9/5',
  label: 'Valutazione ⭐',
  color: 'text-[#16A34A]'
}, {
  value: '🇮🇹',
  label: 'Italia',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'Ho smesso di perdere ore a preparare gli allenamenti. Ora apro Calcio Giovanile Pronto e so esattamente cosa fare.',
  name: 'Marco R.',
  role: 'Allenatore U10'
}, {
  quote: 'I bambini sono più coinvolti e seguono una progressione molto più chiara.',
  name: 'Andrea P.',
  role: 'Allenatore U12'
}, {
  quote: "Finalmente ho una stagione completa organizzata dalla prima all'ultima settimana.",
  name: 'Luca T.',
  role: 'Scuola Calcio'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-169">
      <div className="max-w-5xl mx-auto" data-id="element-170">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-171">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-172">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-173">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-174">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-175">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-176">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-177">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-178">
                "{t.quote}"
              </p>
              <div data-id="element-179">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-180">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-181">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}